import React from 'react';
import starIcon from '../../../assets/dashboard_assets/star.png';

const USAGE_ITEMS = [
    { label: 'Listings', count: 43 },
    { label: 'Listing Score', count: 43 },
    { label: 'Deal Tag & Shipping Timeline Checks', count: 43 },
    { label: 'Catalogue Health Fixes', count: 43 },
];

const CreditsBalance = () => (
    <div className="w-[417px] px-5 pt-8 pb-8 bg-white/80 shadow-[0_0_134px_14px_rgba(120,179,243,0.06)] rounded-3xl outline outline-1 outline-[#D0E7FF] flex flex-col gap-8">
        {/* Credits Balance */}
        <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-2">
                <span className="text-[#2766AA] text-sm font-semibold font-sans opacity-70 uppercase">Credits Balance</span>
                <div className="flex items-center gap-2">
                    <img src={starIcon} alt="credits" className="w-6 h-6" />
                    <span className="text-[#3A3A3A] text-[28px] font-medium font-sans">120</span>
                </div>
                <span className="text-[#737373] text-sm font-medium leading-6 font-sans">
                    Outside your monthly quota · No expiry
                </span>
            </div>
            <div className="flex flex-col gap-2">
                <span className="text-[#737373] text-sm font-medium leading-6 font-sans">
                    Credits are used first before your monthly quota kicks in.
                </span>
                <span className="text-[#737373] text-sm font-bold leading-6 font-sans">
                    120 credits ≈ 24 listings
                </span>
            </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#D0E7FF]" />

        {/* This month's usage */}
        <div className="flex flex-col gap-4">
            <h4 className="text-[#3A3A3A] text-base font-semibold font-sans">This month's usage</h4>
            <div className="flex flex-col gap-3">
                {USAGE_ITEMS.map((item) => (
                    <div key={item.label} className="w-full flex justify-between items-center">
                        <span className="text-[#737373] text-sm font-medium font-sans">{item.label}</span>
                        <span className="text-[#3A3A3A] text-sm font-semibold font-sans">{item.count}</span>
                    </div>
                ))}
            </div>
            <button className="text-[#2766AA] text-sm font-semibold font-sans hover:underline cursor-pointer bg-transparent border-none p-0 text-left">
                View history →
            </button>
        </div>
    </div>
);

export default CreditsBalance;
